/*
* Copyright (C) Regione Lombardia
*/
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { PagesCmsAccessibilitaComponent } from './accessibilita/accessibilita.component';
import { PagesCmsRouting } from './cms.routing';
import { PagesCmsComponent } from './cms/cms.component';
import { PagesCmsContattiComponent } from './contatti/contatti.component';
import { PagesCmsCookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { PagesCmsNoteLegaliComponent } from './note-legali/note-legali.component';
import { PagesCmsPrivacyComponent } from './privacy/privacy.component';
import { PagesCmsRedazioneComponent } from './redazione/redazione.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        PagesCmsRouting,
    ],
    declarations: [
        PagesCmsComponent,
        PagesCmsAccessibilitaComponent,
        PagesCmsContattiComponent,
        PagesCmsCookiePolicyComponent,
        PagesCmsNoteLegaliComponent,
        PagesCmsPrivacyComponent,
        PagesCmsRedazioneComponent,
    ],
    exports: [
        PagesCmsComponent,
        PagesCmsAccessibilitaComponent,
        PagesCmsContattiComponent,
        PagesCmsCookiePolicyComponent,
        PagesCmsNoteLegaliComponent,
        PagesCmsPrivacyComponent,
        PagesCmsRedazioneComponent,
    ],
})
export class PagesCmsModule { }
